import type { ReactNode } from 'react'

interface EmptyStateProps {
  title: string
  description?: string
  action?: ReactNode
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-4 py-16 text-center">
      <img
        src="/3d/black-flower.png"
        alt=""
        className="h-40 w-40 select-none object-contain opacity-90"
      />
      <div className="flex flex-col gap-1">
        <p className="t-h3 text-text-primary">{title}</p>
        {description && <p className="text-text-tertiary">{description}</p>}
      </div>
      {action}
    </div>
  )
}
